import { Question } from './question.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class SelfExamQuestion extends Question {
  public static fromDto(dto: any): SelfExamQuestion {
    const question: SelfExamQuestion = new SelfExamQuestion();
    Question.mapBaseProperties(question, dto);
    return question;
  }
}
